import api from '@/api/user';
import errorModel from '@/model/error';
import store from '@/store';

export default {
  fetchSelf() {
    return new Promise((resolve, reject) => {
      api.fetchSelf({}, true)
        .then(r => ({ ...r, '@id': `/api/users/${r.id}` }))// todo remove. Temporary fix for /api/self endpoint
        .then(r => { store.commit('auth/setUser', r); resolve(r); })
        .catch(() => { reject(); });
    });
  },

  /**
   * Вход под другим пользователем; '_exit' возвращает обратно в свой аккаунт.
   *
   * Пользователя этот запрос не отдаёт: на _switch_user сервер отвечает
   * редиректом, и промис всегда отклоняется — но сессия к этому моменту уже
   * переключена. Поэтому актуального пользователя забираем отдельным
   * fetchSelf, а ошибку первого запроса гасим: она штатная и показывать её
   * не нужно (иначе она осядет в store и на следующей навигации подменит
   * экран на ErrorPage).
   */
  impersonate(username = '_exit') {
    return api.fetchSelf({ _switch_user: username }, true)
      .catch(() => { errorModel.clear(); })
      .then(() => this.fetchSelf());
  },
};
